import React, { useState, useEffect } from "react";
import { PageHeader } from "components/ui";
import {
    Grid,
    Box,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
} from "@mui/material";
import GriStandardsSelector from "components/customizedStandardsComponent/GriStandardsSelector";
import GriFormComponent from "components/customizedStandardsComponent/GriFormComponent";
import UploadEvidenceComponent from "components/customizedStandardsComponent/UploadEvidenceComponent";
import DownloadReport from "components/customizedStandardsComponent/DownloadReport";
import DownloadPostReviewGapForm from "components/customizedStandardsComponent/DownloadPostReviewGapForm";
import UploadPostReviewGapForm from "components/customizedStandardsComponent/UploadPostReviewGapForm";
import DownloadPostReviewReports from "components/customizedStandardsComponent/DownloadPostReviewReports";
import StandardsSelector from "components/customizedStandardsComponent/GriStandardsSelector";
import NavigationButtons from "helper/navigation/NavigationButtons";
import { Climate_Related_Financial_Disclosure_Form } from "data/forms/griFormSchema";
import { ESG_AUTO_SYNCED_SUSTAIN_DASHBOARD, UPCOMING_FEATURES } from "data/standards/griStandards";
import { customItemsScenarioAnalysis, ESGVerificationModule_step_1, identifyIndustryWorkEnviroment, Reviewand_Findings, Standards_Legal_Benchmark_Cross_Check, Verification_Checks } from "data/reports/relevantReports";
import ReportsReviewDialog from "components/customizedStandardsComponent/ReportsReviewDialog";
import UploadEvidenceReviewReports from "components/customizedStandardsComponent/UploadEvidenceReviewReports";
import {
    industrailIdentification,
    natureOfActivities,
} from "data/reports/relevantReports";
import ESGVerificationDashboard from "components/customizedStandardsComponent/ESGVerificationDashboard";
const VerificationDashboard = () => {
    const [activeStep, setActiveStep] = useState(0);
    const [prevStep, setPrevStep] = useState(0);
    const [reportData, setReportData] = useState({
        selectedStandards: [],
        companyInfo: {},
    });
    const [showReviewPopup, setShowReviewPopup] = useState(false);

    const steps = ["Select GRI Standards"];

    // useEffect(() => {
    //     if (activeStep === 4 && prevStep === 3) {
    //         setShowReviewPopup(true);
    //     }
    // }, [activeStep, prevStep]);

    const handleNext = () => {
        setPrevStep(activeStep);
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setPrevStep(activeStep);
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleSaveStandards = (selectedStandards) => {
        setReportData((prev) => ({
            ...prev,
            selectedStandards,
        }));
        console.log("Standards saved:", selectedStandards);
    };

    const handleClosePopup = () => {
        setShowReviewPopup(false);
    };

    const handleSkipToStep5 = () => {
        setPrevStep(activeStep);
        setActiveStep(5);
        setShowReviewPopup(false);
    };

    const getStepContent = (step) => {
        switch (step) {
            case 0:
                return (
                    <ESGVerificationDashboard
                        key="esg-dashboard"
                        onPrevious={handleBack}
                        onNext={handleNext}
                        title="ESG Verification Dashboard"
                    />
                )
            default:
                return "Unknown step";
        }
    };

    return (
        <>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                        <PageHeader title="AI-Powered ESG Reporting across Global, National, Sectoral, and Industry-Specific Standards" />
                    </Box>
                    <Grid item xs={12}>
                        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                            <NavigationButtons
                                imageKey="dashboardImg7_2"
                                title={"Verification Module"}
                                activeStep={activeStep}
                                onBack={handleBack}
                            />
                        </Box>
                    </Grid>
                </Grid>

                <Grid item xs={12}>
                    {getStepContent(activeStep)}
                </Grid>

                <Grid item xs={12}>
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            mt: 4,
                            mb: 2,
                        }}
                    ></Box>

                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            mt: -1,
                        }}
                    >
                        {steps.map((_, index) => (
                            <Box
                                key={index}
                                sx={{
                                    width: 10,
                                    height: 10,
                                    borderRadius: "50%",
                                    backgroundColor: index <= activeStep ? "#02462E" : "#e0e0e0",
                                    mx: 1,
                                }}
                            />
                        ))}
                    </Box>
                </Grid>
            </Grid>

            <ReportsReviewDialog
                open={showReviewPopup}
                onClose={handleClosePopup}
                onSkip={handleSkipToStep5}
            />
        </>
    );
};

export default VerificationDashboard;
